import { ActionMeta } from 'react-select'
import type { OptionType } from '../../types/utilities'

const isEmail = (emailCandidate: string): boolean => {
    const reg = /^[^\s@]+@[^\s@]+$/

    return reg.test(emailCandidate)
}

const sanitizeOptions = (options: string[]): string[] => {
    return options.map((elem: string) => sanitizeOption(elem))
}

const sanitizeOption = (options: string, replaceValue = ''): string => {
    return (
        options
            // eslint-disable-next-line no-useless-escape
            .replace(/[\n\r\t\<\>\"\'\,\!\?\(\)\#\$\%\&\*\+]/g, replaceValue)
            .toLowerCase()
            .trim()
    )
}

const inputCase = (input: string): string => {
    if (input.includes('<') || input.includes('>')) return '<>'
    else if (input.includes(',')) return 'comma'
    else if (input.includes('\n')) return 'scape'
    else if (input.split(' ').length > 1) return 'space'

    return 'single'
}

const splitEmail = (input: string): string[] => {
    if (!input) return []

    let setInput: string[] = []

    switch (inputCase(input)) {
        /*  
            0 - 'email@domain' -> single option/input
            1 - '<email@domain>'
            2 - '\nemail@domain'
            3 - 'email@domain wuth_some_space'
            4 - 'email@domain,'
        */
        case 'single':
            setInput = [input.trim()]
            break
        case 'space':
            setInput = [...input.split(' ')]
            break
        case 'comma':
            setInput = [...input.split(',')]
            break
        case '<>':
            setInput = [...sanitizeOption(input, ' ').split(' ')]
            break
        case 'scape':
            setInput = [...input.split('\n')]
            break
        default:
            setInput = []
    }

    return sanitizeOptions(setInput).filter((email: string) => isEmail(email))
}

interface SetOptionsInfo {
    eValues: string[]
    msg: string
    changes: string[]
}

const setOptions = (values: string[], emails: OptionType[], event: ActionMeta<OptionType>): SetOptionsInfo => {
    let msg = ''
    switch (event.action) {
        case 'create-option': {
            const input = emails[emails.length - 1].value
            const res = splitEmail(input as string)
            if (res.length === 0) return { eValues: [...values], msg: 'error', changes: [input as string] }
            // looking for duplicated emails
            const duplicatas: string[] = []
            const withoutDuplicatas = [...values, ...res].reduce((result: string[], currElem) => {
                if (!result.some(elem => elem === currElem)) {
                    result.push(currElem)
                } else {
                    duplicatas.push(currElem)
                    msg = 'warning'
                }

                return result
            }, [])

            return {
                eValues: withoutDuplicatas,
                msg: msg || 'success',
                changes: duplicatas.length ? duplicatas : res
            }
        }

        case 'remove-value': {
            const { removedValue } = event
            const removeValueResult = values.reduce((res: string[], curr) => {
                if (curr !== removedValue.value) {
                    res.push(curr)
                }

                return res
            }, [])

            return { eValues: removeValueResult, msg: 'removed', changes: [removedValue.value as string] }
        }
        default:
            return { eValues: values, msg: '?', changes: [] }
    }
}
export { isEmail, sanitizeOptions, inputCase, setOptions, splitEmail }
